import { useRouter } from 'expo-router';
import { View, Text, Pressable, Image as RNImage } from 'react-native';
import { StyleSheet } from 'react-native-unistyles';
import { Image } from 'expo-image';
import { useEffect, useState } from 'react';
import { buildLinkPreview, getOG } from '../../utils/og';
import { ActivityIndicator } from 'react-native-paper';
import Clipboard from '@react-native-clipboard/clipboard';
import Toast from 'react-native-toast-message';
import usePlatform from '@/utils/hooks/usePlatform';


const LinkPreview = ({url, linkObject = {}, widthDivisor = 250, containerWidth = null, invertColors = false}) => {
    const [link, setLink] = useState({})
    const [loadingLink, setLoadingLink] = useState(true)

    const router = useRouter();
    const { isWeb } = usePlatform();

    useEffect(() => {
        setLinkOG(url);
    }, [url])

    const setLinkOG = async (link) => {
        const ogInfo = await getOG(link);
        const imageInfo = buildLinkPreview(ogInfo);

        if(imageInfo.ogImage?.url && imageInfo.ogImage?.width && imageInfo.ogImage?.height){
            RNImage.getSize(imageInfo.ogImage?.url, (imageWidth, imageHeight) => {
                let maxSizeDivisor = Math.max(imageWidth, imageHeight) / widthDivisor;

                setLink({originalURL:link, ...imageInfo, ogImage: {...imageInfo.ogImage, width: imageWidth / maxSizeDivisor, height: imageHeight / maxSizeDivisor}});
                setLoadingLink(false)
            })
        }
        else{
            let maxSizeDivisor = Math.max(imageInfo.ogImage?.width, imageInfo.ogImage?.height) / widthDivisor;
            setLink({originalURL:link, ...imageInfo, ogImage: {...imageInfo.ogImage, width: 300 / maxSizeDivisor, height: 300 / maxSizeDivisor}});
            setLoadingLink(false)
        }
    }

   // let maxSizeDivisor = useMemo(() => (link.ogImage?.width && link.ogImage?.height) ? Math.max(link.ogImage?.width, link.ogImage?.height) / widthDivisor : 1, [link.ogImage?.height, link.ogImage?.width])
    const title = linkObject?.name || link?.ogTitle;
    const isExpired = linkObject?.expiration && new Date(linkObject?.expiration) < new Date()
    
    return (
        <Pressable 
            disabled={isExpired} 
            onLongPress={() => {
                Clipboard.setString(link.originalURL);
                Toast.show({type:"success", text2:"Copied URL to clipboard!"})
            }} 
            onPress={() => isWeb ? window.open(link.originalURL, "_blank") : router.push({pathname: "/(utilities)/webview", params: {url: link.originalURL, title}})} 
            key={link.originalURL} 
            style={styles.pressable({
                containerWidth, 
                imageWidth: link.ogImage?.width, 
                invertColors, 
                isExpired
            })}
        >
            { loadingLink
                ? <View style={styles.loadingContainer({invertColors})}>
                    <ActivityIndicator size="small" />
                </View>
                : <>
                    {link.ogImage?.url &&
                        <View style={styles.imageContainer}>
                            <Image 
                                contentFit="cover" 
                                source={{uri:link.ogImage?.url}} 
                                style={styles.previewImage({
                                    height: Number(link.ogImage?.height), 
                                    width: Number(link.ogImage?.width)
                                })} 
                            />
                        </View>
                    }
                
                    <View style={styles.contentContainer({invertColors, hasImage: !!link.ogImage?.url})}>
                        {title && <Text style={styles.titleText} numberOfLines={2}>{title}</Text> }
                        {isExpired && <Text style={styles.expiredText}>This link has expired</Text>}
                        <View style={styles.urlContainer}>
                            <Text style={styles.urlText} numberOfLines={1} ellipsizeMode="middle">
                                {link.originalURL?.toLowerCase().replace("http://", "").replace("https://", "")}
                            </Text>
                            <Image contentFit="cover" source={{uri:link.icon}} style={styles.iconImage} />
                        </View>
                    </View>
                </>
            }
        </Pressable>
    )
}

const styles = StyleSheet.create(({colors}) => ({
    pressable: ({containerWidth, imageWidth, invertColors, isExpired}) => ({
        width: containerWidth ? imageWidth : "100%",
        borderWidth: 2,
        borderColor: invertColors ? colors.background : colors.surface,
        borderRadius: 8,
        opacity: isExpired ? 0.6 : 1
    }),
    loadingContainer: ({invertColors}) => ({
        borderTopLeftRadius: 5,
        borderTopRightRadius: 5,
        overflow: "hidden",
        height: 100,
        backgroundColor: invertColors ? colors.background : colors.surface,
        justifyContent: "center",
        alignItems: "center"
    }),
    imageContainer: {
        borderTopLeftRadius: 5,
        borderTopRightRadius: 5,
        overflow: "hidden",
        justifyContent: "center",
        alignItems: "center"
    },
    previewImage: ({height, width}) => ({
        height: height,
        width: width
    }),
    contentContainer: ({invertColors, hasImage}) => ({
        justifyContent: "center",
        backgroundColor: invertColors ? colors.background : colors.surface,
        padding: 10,
        borderBottomLeftRadius: 5,
        borderBottomRightRadius: 5,
        ...(hasImage ? {} : {
            borderTopLeftRadius: 5,
            borderTopRightRadius: 5
        })
    }),
    titleText: {
        color: colors.text,
        fontSize: 12,
        fontWeight: "bold",
        paddingRight: 5
    },
    expiredText: {
        color: colors.error,
        fontStyle: "italic",
        fontSize: 11,
        paddingTop: 2
    },
    urlContainer: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        paddingTop: 2
    },
    urlText: {
        color: colors.textSecondary,
        flexShrink: 1,
        fontSize: 11,
        paddingRight: 5
    },
    iconImage: {
        height: 20,
        width: 20,
        borderRadius: 8
    }
}));

export default LinkPreview;
